import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';

export interface AssignmentCalendarFooterProps {
  teamDayTotal: number[];
  teamTotalR: number;
  teamTotalE: number;
}

export const AssignmentCalendarFooter = ({ teamDayTotal, teamTotalR, teamTotalE }: AssignmentCalendarFooterProps) => {
  return (
    <div className={assignmentsStyles["assigcalenfooter"]}>
      {/* Primera columna: Espacio vacío para alinear con la columna de usuarios */}
      <div className={assignmentsStyles["assigcalenfooter__col"]}>
        <div className={assignmentsStyles["assigcalenfooter__space"]} />
      </div>
      
      {/* Segunda columna: Totales diarios */}
      <div className={assignmentsStyles["assigcalenfooter__col"]}>
        <div className={assignmentsStyles["assigcalenfooter__days-wrapper"]}>
          {teamDayTotal.map((hour, index) => {
            const key = `day-total-${index}-${hour}`;
            return (
              <div className={assignmentsStyles["assigcalenfooter__day"]} key={key}>
                {hour > 0 ? hour.toFixed(1) : '0'}
              </div>
            );
          })}
        </div>
      </div>

      {/* Tercera columna: Totales semanales */}
      <div className={assignmentsStyles["assigcalenfooter__col"]}>
        <div className={assignmentsStyles["assigcalenfooter__totals-wrapper"]}>
          <div className={assignmentsStyles["assigcalenfooter__totalE"]}>
            {teamTotalE.toFixed(1)}
          </div>
          <div className={assignmentsStyles["assigcalenfooter__totalR"]}>
            {teamTotalR.toFixed(1)}
          </div>
        </div>
      </div>
    </div>
  );
};